<div
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.borderColor]="textColor | contentBuilderColor"
  class="mt-16"
>
  <div
    class="flex flex-grow px-6 py-4 mx-5 border border-4 border-solid rounded-lg"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
    [style.borderColor]="textColor | contentBuilderColor"
  >
    <input
      appVirtualKeyboard
      type="text"
      [(ngModel)]="voucher"
      [isOverFooter]="true"
      class="flex flex-grow text-2xl border border-none outline-none focus:outline-none focus:ring-0"
      placeholder="Saisir un code promo"
      [style.backgroundColor]="backgroundColor | contentBuilderColor"
    />
    <app-button-atom
      size="M"
      thickSize="M"
      label="Ajouter"
      [overrideBgColor]="primaryButtonBackgroundColor"
      [overrideTextColor]="primaryButtonTextColor"
      type="kiosk-primary"
      [full]="true"
      (click)="applyVoucher(voucher)"
    ></app-button-atom>
  </div>
  <div
    *ngIf="errorVoucher"
    class="pt-5 pl-5"
  >
    {{ errorVoucher }}
  </div>
  <div
    *ngFor="let coupon of (order$ | async)?.coupons"
    class="flex justify-between px-4 py-6 m-5 border-b border-neutral-300"
    [style.backgroundColor]="primaryButtonTextColor | contentBuilderColor"
    [style.color]="primaryButtonBackgroundColor | contentBuilderColor"
    [class.opacity-50]="coupon.removeInProgress"
  >
    <div class="leading-snug lg:text-base">
      <div class="pb-5 text-xl font-bold">
        <ng-container *ngIf="coupon.name">
          {{ coupon.name }}
        </ng-container>
        <ng-container *ngIf="!coupon.name">
          {{ 'basket.discount-voucher' | translate }} «{{ coupon.code }}»
        </ng-container>
      </div>
      <div
        *ngIf="coupon.type === 'ERROR'"
        class="text-xs text-error-800"
      >
        <ng-container *ngIf="coupon.error">
          {{ 'voucher-modal.voucher-not-available' | translate }}
        </ng-container>
        <ng-container *ngIf="!coupon.error">
          {{ 'basket.invalid-voucher' | translate }}
        </ng-container>
      </div>
      <div>
        <app-button-atom
          size="M"
          thickSize="S"
          label="Supprimer"
          [overrideBgColor]="secondaryButtonBackgroundColor"
          [overrideTextColor]="secondaryButtonTextColor"
          type="kiosk-primary"
          [full]="true"
          (click)="removeCoupon(coupon)"
        ></app-button-atom>
      </div>
    </div>
    <div class="flex flex-row items-center justify-end">
      <div
        class="pl-4 icon icon-coupon-3 text-neutral-400"
        *ngIf="coupon.type !== 'ERROR'"
      ></div>
      <div
        class="pl-4 icon icon-warning-circle text-error-800"
        *ngIf="coupon.type === 'ERROR'"
      ></div>
      <div
        class="w-20 text-sm leading-5 text-right"
        *ngIf="coupon.type !== 'ERROR'"
      >
        –
        <app-price-atom
          [bold]="false"
          [amount]="coupon.amount_off"
          [format]="true"
        ></app-price-atom>
      </div>
    </div>
  </div>
</div>
